<template>
  <div>
    <PersonShortInfo
      v-if="originalAppointment && originalAppointment.person"
      class="mb-4"
      :person="originalAppointment.person"
      :serviceSlug="serviceSlug"
      @closeAppointmentDetailsModal="closeAppointmentDetailsModal"
    />

    <AppointmentShortInfo
      v-if="originalAppointment"
      :appointment="originalAppointment"
      :serviceSlug="serviceSlug"
      @closeAppointmentDetailsModal="closeAppointmentDetailsModal"
    />
  </div>
</template>
<script>
import AppointmentShortInfo from '@/components/clinical/appointments/AppointmentShortInfo'
import PersonShortInfo from '@/components/clinical/people/PersonDetails/PersonShortInfo'
export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
    appointment: {
      type: Object,
      required: true
    }
  },
  components: {
    AppointmentShortInfo,
    PersonShortInfo
  },
  methods: {
    closeAppointmentDetailsModal: function () {
      this.$emit('closeAppointmentDetailsModal')
    }
  },
  computed: {
    originalAppointment: function () {
      if (this.appointment.parent) {
        return this.appointment.parent
      }
      return this.appointment
    },
    getAppointmentTypeLabel: function () {
      if (!this.originalAppointment.type) return null
      let label = this.originalAppointment.type.name
      if (this.originalAppointment.type.slug && label !== this.originalAppointment.type.slug) {
        label += ` (${this.originalAppointment.type.slug})`
      }
      return label
    }
  }
}
</script>
<style lang="scss">
.personal-info, .appointment-info {
  & h6 {
    font-weight: bold;
    margin-bottom: 1rem;
  }
  & div {
    margin-left: 1rem;
    margin-bottom: 0.7rem;
    color: #48494B;
    & span {
      font-weight: bold;
    }
  }
}
</style>
